import React, { useState, useEffect, useRef } from 'react';
import { FaSave, FaUser } from 'react-icons/fa';
import { Modal } from './common';
import './Modal.css';

const EditNameModal = ({ isOpen, onClose, employee, onSave }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    segundo_nombre: '',
    apellido: '',
    segundo_apellido: ''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const firstInputRef = useRef(null);

  useEffect(() => {
    if (employee && isOpen) {
      setFormData({
        nombre: employee.primer_nombre || '',
        segundo_nombre: employee.segundo_nombre || '',
        apellido: employee.apellido || '',
        segundo_apellido: employee.segundo_apellido || ''
      });
      setError(null);
      setTimeout(() => {
        firstInputRef.current?.focus();
        firstInputRef.current?.select();
      }, 100);
    }
  }, [employee, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const capitalized = value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    setFormData(prev => ({ ...prev, [name]: capitalized }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nombre.trim() || !formData.apellido.trim()) return;

    setSaving(true);
    setError(null);

    try {
      await onSave(employee.id, formData);
      onClose();
    } catch (err) {
      console.error('Error al guardar:', err);
      setError('Error al guardar los cambios. Intente nuevamente.');
    } finally {
      setSaving(false);
    }
  };

  // Asi se muestra en Centro Sura: los segundos son solo referenciales
  const previewName = [formData.nombre, formData.apellido].filter(Boolean).join(' ') || 'Sin nombre';

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <Modal.Header onClose={onClose}>
        <FaUser className="mr-2" />
        Editar Nombre
      </Modal.Header>
      <Modal.Body>
        {saving ? (
          <div className="loading">
            <div className="spinner"></div>
            <p>Guardando cambios...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} id="edit-name-form">
            <div className="name-fields-grid">
              <div className="form-group">
                <label htmlFor="nombre">Primer Nombre *</label>
                <input
                  ref={firstInputRef}
                  type="text"
                  id="nombre"
                  name="nombre"
                  className="input"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  placeholder="Ej: Juan"
                />
              </div>
              <div className="form-group">
                <label htmlFor="segundo_nombre">Segundo Nombre</label>
                <input
                  type="text"
                  id="segundo_nombre"
                  name="segundo_nombre"
                  className="input"
                  value={formData.segundo_nombre}
                  onChange={handleChange}
                  placeholder="Ej: Carlos"
                />
              </div>
              <div className="form-group">
                <label htmlFor="apellido">Primer Apellido *</label>
                <input
                  type="text"
                  id="apellido"
                  name="apellido"
                  className="input"
                  value={formData.apellido}
                  onChange={handleChange}
                  required
                  placeholder="Ej: Perez"
                />
              </div>
              <div className="form-group">
                <label htmlFor="segundo_apellido">Segundo Apellido</label>
                <input
                  type="text"
                  id="segundo_apellido"
                  name="segundo_apellido"
                  className="input"
                  value={formData.segundo_apellido}
                  onChange={handleChange}
                  placeholder="Ej: Garcia"
                />
              </div>
            </div>

            <div className="info-preview" style={{ marginTop: '1rem' }}>
              <p><strong>Vista previa:</strong> {previewName}</p>
            </div>

            {error && (
              <div className="error-message">
                <p>{error}</p>
              </div>
            )}
          </form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onClose} disabled={saving}>
          Cancelar
        </button>
        <button
          type="submit"
          form="edit-name-form"
          className="btn btn-primary"
          disabled={saving || !formData.nombre.trim() || !formData.apellido.trim()}
        >
          <FaSave className="mr-2" />
          {saving ? 'Guardando...' : 'Guardar'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditNameModal;
